import React from 'react';
import { Navbar } from 'react-bootstrap';
import '../../styles/NavBar.scss';

export const NavBar = () => {
	return (
		<Navbar style={{ backgroundColor:"#284F7A" }} className='justify-content-between navbar-height'>
			<Navbar.Brand href='/' style={{  maxHeight:"120px", maxWidth:"180px" }}>
				<div className='navbar-logo'></div>
			</Navbar.Brand>
			<h3 className='navbar-text'>Celebremos San Nicolás</h3>
		</Navbar>
	);
};
